export default __webpack_public_path__ + "static/media/hourglass.e232e32d.svg";